import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();

export const loadPhotos = (force = false) => {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api
      .get("/photos")
      .then((r) => {
        cache = r.data;
        listeners.forEach((fn) => fn(cache));
        return cache;
      })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const refreshPhotos = () => loadPhotos(true);

export const usePhotos = (section, tag) => {
  const [all, setAll] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let on = true;
    const sync = (d) => on && setAll(d);
    listeners.add(sync);
    loadPhotos().then((d) => { if (on) { setAll(d); setLoading(false); } }).catch(() => on && setLoading(false));
    return () => { on = false; listeners.delete(sync); };
  }, []);

  const photos = useMemo(
    () => all.filter((p) => p.section === section && (tag === undefined || p.tag === tag)),
    [all, section, tag]
  );
  return { photos, loading, first: photos[0] || null };
};
